(function($, B) {
    'use strict';
    B.web.toInit['map'] = true;
    B.web.widgets['map'] = {
        enabled: true,
        selectors: {
            maps: '[data-map]'
        },
        $elements:{
        },
        data:{           
            twardogora: {
                longtitude: 17.472408,
                latitude: 51.367329
            },
            goszcz: {
                longtitude: 17.480215,
                latitude: 51.396447
            },
            grabowno:{
                longtitude: 17.408815,
                latitude: 51.343938
               
            }
        },
        init:function(){
            Bajt.web.getElements(this.selectors, this.$elements);
            if(this.$elements.maps){
                var that = this;
                this.enabled = true;
                this.$elements.maps.each(function(){
                    that.initMap($(this));
                });
            }
        },
        initMap:function($map){
            var o = $.extend({
                    zoom: 18
                }, $map.data());
            // $map.css('height', '300px');
            // Create Leaflet map on map element.
            var map = L.map($map[0]),
                latitude = o.latitude || this.data[o.map].latitude,
                longtitude = o.longtitude || this.data[o.map].longtitude;

            // Add OSM tile leayer to the Leaflet map.
            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            // Target's GPS coordinates.
            var target = L.latLng(latitude, longtitude);

            // Set map's center to target with zoom 14.
            map.setView(target, o.zoom);

            // Place a marker on the same location.
            L.marker(target).addTo(map);

        }
    };
})(jQuery, Bajt);
